import { render, staticRenderFns } from "./HomeMenu.vue?vue&type=template&id=147d4ed0&scoped=true&"
import script from "./HomeMenu.vue?vue&type=script&lang=js&"
export * from "./HomeMenu.vue?vue&type=script&lang=js&"
import style0 from "./HomeMenu.vue?vue&type=style&index=0&id=147d4ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../explorakit/vue-explorakit/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147d4ed0",
  null
  
)

export default component.exports